<template>
  <div @click="focusSelf($event)" @keyup.enter="customEnter">
    <!--有label設定時就會產生label,顯示在上面多出一行-->
    <label v-if="label" 
      :class="(!checkMobile()&&componentType.split('-').slice(-1)[0]==='group')?'float-left':''" 
      :for="akey">{{label}}</label>
    <component 
      :is="whichComponent"
      :type="whichComponent==='b-form-input'?componentType:undefined"
      :id="akey?(fkey+'_'+akey):undefined"
      ref="comp"
      :inputId="componentType==='vue-single-select'?('i'+fkey+'_'+akey):undefined"
      :options="!customSelectObject?selectOptions:undefined"
      :option-label="optionLabel"
      :required="isRequired"
      :asyncFetch="componentType==='vue-single-select'?asyncFetch:undefined"
      :asyncDelayMS="componentType==='vue-single-select'?asyncDelayMS:undefined"
      @search-text-change="asyncFetchCB"
      @click.prevent.stop="execCommand(execCallback,$event)"
      :rows="rows"
      :max="max?max:undefined"
      :min="min?min:undefined"

      :config="dpConfig"

      :minute-interval="minuteInterval"
      :format="timeFormat"
      :minHour="minHour"
      :maxHour="maxHour"
     
      :style="cStyle"
      :class="cClass"
      :disabled="disabled"

      :defaultValue="defaultValue"
      :placeholder="placeholder"
      
      v-model="modelIndex"
      
      :state="validateState"

      :loc="loc?loc:undefined"

      :star-size="componentType==='star-rating'?(starSize?starSize:20):undefined"
      :read-only="componentType==='star-rating'?(disabled?true:false):undefined"
      :show-rating="componentType==='star-rating'?(showRating?showRating:false):undefined"
      :increment="componentType==='star-rating'?(increment?increment:1):undefined"
      :max-rating="componentType==='star-rating'?(maxRating?maxRating:5):undefined"

      :stacked="groupStacked || checkMobile()"
    >
      <!--option是form b-form-select的屬性-->
      <option :value="null" :disabled="isRequired" v-if="customSelectObject&&placeholder&& !hide">
        {{placeholder}}
      </option>
      <option v-for="option in selectOptions" :value="option" :key="option.id" v-show="customSelectObject && !hide">
        {{option[optionLabel]}}
      </option>
      <!--checkbox-->
      <span v-if="componentType==='b-form-checkbox'&&!hide">{{placeholder}}</span>
      <font-awesome-icon v-if="componentType==='b-button'&&btnIcon&&!hide" class="m-auto" style="" fixed-width :icon="['fas',btnIcon]" />
      {{((componentType==='b-button'||componentType==='span')&&!hide)?placeholder:''}}
      <template v-if="componentType==='btn-group'&&!hide" style="overflow-x: hidden;">
          <b-button 
            v-for="btn in buttons" 
            :key="btn.akey" 
            :class="'col-'+btn.col+(((btn.placeholder||btn.btnIcon)&&!btn.hide)?'':' hide')"
            style="margin-right:5px;"
            @click.prevent.stop="execCommand(btn.execCallback,$event)"
          >
          <font-awesome-icon v-if="btn.btnIcon&&!btn.hide" fixed-width :icon="['fas',btn.btnIcon]" />
          {{btn.placeholder}}
          </b-button>
        
      </template>
    </component>
    <!--原本是使用b-form-invalid-feedback綁定控制...但最後發現自己用div控制比較方便 -->
    <div class="feedback-hint" v-if="validatePrompt&&!validateState&&!hide" :id="'vph_'+akey">
      {{validateHint}}
    </div>
    <div v-if="validatePrompt&&validateState" class="prompSpace"></div>
    <b-tooltip v-if="title" :target="() => $refs.comp" >
      {{title}}
    </b-tooltip>
  </div>
</template>

<script>

// import 所有支援的controls於此,被form用設定資料foreach產生
import IframeMap from './IframeMap'
import VueTimepicker from 'vue2-timepicker'

export default {
  name: 'FieldContainer',
  components: {
    /* eslint-disable vue/no-unused-components */
    IframeMap,
    VueTimepicker
  },
  data: function () {
    return {
      validateState:undefined,
      waiting:false,
      dpConfig:{}
    }
  },
  props: {
    'componentType':String,
    'selectOptions':Array,
    'defaultValue':[String,Object,Number,Boolean],
    'max':[String,Number],
    'min':[String,Number],
    'option-label':String,
    'optionVar':String,
    'placeholder':String,
    'formDataObj':Object,
    'disabled':Boolean,
    'centerText':Boolean,
    'isRequired':Boolean,
    'asyncDelayMS':Number,
    'starSize':Number,
    'showRating':Boolean,
    'increment':Number,
    'maxRating':Number,
    'rows':Number,
    'asyncFetch':Boolean,
    'asyncFetchCB':{
      type:Function,
      default: function () {
        return
      }
    },
    'execCallback': {
      type:Function,
      default: undefined
    },
    'waitClick':Boolean,
    'validatePrompt':Boolean,
    'validatePromptHint':String,
    'fkey':String,
    'akey':String,
    'title':String,
    'label':String,
    'datePickerConfig':Object,
    'customValidateCB':Function,
    'groupStacked': Boolean,
    'customSelectObject':Boolean,
    'loc':Object,
    'hide':Boolean,
    'buttons':Array,
    'minuteInterval':Number,
    'timeFormat':String,
    'minHour':Number,
    'maxHour':Number,
    'btnIcon':String,
  },
  methods: {
    clearSelectLocalValue() {
      if (this.componentType === 'b-form-select') {
        this.$refs.comp.localValue = null
      }
      else if (this.componentType === 'vue-single-select') {
        this.$refs.comp.selectedOption = null
      }
    },
    setSelectedValue() {
      // 讓b-form-select預設值可以預設被選取需要花不少功夫...
      // 但機車的是...程式操作的和UI點擊操作的連動有問題＝＝
      if (this.componentType === 'b-form-select') {
        // 不稍等的話剛更新的this.formDataObj[this.akey]會沒有讀取到
        setTimeout(() => {
          for (let i=0;i<this.$refs.comp.$el.children.length;i++) {
            if (!this.formDataObj[this.akey]) {
              // 空值要找預設選項選起來...這個抽出來例外判斷是因為兩種類型(OptionVar與dataOptions)都一樣判斷即可
              if (!this.$refs.comp.$el.children[i].value) {
                this.$refs.comp.$el.children[i].setAttribute('selected',true)
                // 永遠強制設置成null回到預設選項未選
                this.$refs.comp.localValue = this.formDataObj[this.akey]
                return
              }
            }
            else {
              // [object Object]的字串很囧...前面o小寫後面O大寫
              //if (this.$refs.comp.$el.children[i].value === "[object Object]") {
              // 暫時改用這個判斷,還要再測試看看
              if (typeof this.$refs.comp.$el.children[i]._value === 'object' ) {
                // optionVar動態變數選項模式的選定值設定還沒實作
                // 判斷較麻煩,因為選取的是object,所以得要比到裡面的id屬性,或是風險較高的Object stringify全比較
                if (JSON.stringify(this.$refs.comp.$el.children[i]._value) === JSON.stringify(this.formDataObj[this.akey])) {
                  this.$refs.comp.$el.children[i].setAttribute('selected',true)
                  this.$refs.comp.localValue = this.formDataObj[this.akey]
                  return
                }
              }
              else {
                // 簡單選項dataOptions設定綁定值選取
                if (this.$refs.comp.$el.children[i].value == this.formDataObj[this.akey]) {
                  // 手動更新下拉選項的選項組合與值再更新view時會碰到殘存local value與設定值不一樣,要先蓋掉再設selected否則選取不起來
                  if (this.$refs.comp.localValue !== undefined && this.$refs.comp.localValue != this.formDataObj[this.akey]) {
                    this.$refs.comp.localValue = this.formDataObj[this.akey]
                  }
                  this.$refs.comp.$el.children[i].setAttribute('selected',true)
                  // 在有共用組件,但動態切換下拉選單選項時(切換tab時dataOptions跟著動態換,且不是套OptionVar的模式)...localValue時不時會變成undefined而無法顯示選取項目
                  // 加上這個判斷補起來
                  if (this.$refs.comp.localValue === undefined) {
                    this.$refs.comp.localValue = this.formDataObj[this.akey]
                  }
                  return
                }
              }
            }
          }
        }, 50);
      }
    },
    setCheckedValue(val) {
      if (this.componentType === 'b-form-checkbox' || this.componentType === 'b-form-radio-group') {
        this.$refs.comp.localChecked = val
      }
    },
    setPickTime(val) {
      if (this.componentType === 'vue-timepicker') {
        if (val) {
          //this.$refs.comp.renderHoursList()
          this.$refs.comp.setValueByTimeStr(val)
        }
        else {
          this.$refs.comp.clearTime()
        }
      }
    },
    setDisabled(disabled = true) {
      if (disabled) {
        if (['b-button'].includes(this.componentType)) {
          this.$refs.comp.setAttribute('disabled',true)
        }
        // 可能還有各種例外的set disabled需求,碰到再修正
        else if (['b-form-checkbox'].includes(this.componentType)) {
          this.$refs.comp.$el.children[0].setAttribute('disabled',true)
        }
        else {
          this.$refs.comp.$el.setAttribute('disabled',true)
        }
      }
      else {
        if (['b-button'].includes(this.componentType)) {
          this.$refs.comp.removeAttribute('disabled')
        }
        else if (['b-form-checkbox'].includes(this.componentType)) {
          this.$refs.comp.$el.children[0].removeAttribute('disabled')
        }
        else {
          this.$refs.comp.$el.removeAttribute('disabled')
        }
      }
    },
    resetDatePickConfig(config) {
      this.dpConfig = config
    },
    inputValidateCheck () {
      // validatePrompt且未指定自訂的輸入驗證時,預設檢查必填與當前的值,回傳true/false給validateState
      if (this.validatePrompt && this.customValidateCB && typeof this.customValidateCB === 'function') {
        return this.customValidateCB(this.formDataObj[this.akey])
      }
      else if (!this.validatePrompt) {
        // 很難移掉validated的b-form-select(會插入一個綠色勾勾svg圖 原本還有上下箭號圖 background有兩張圖),所以下拉選單不套validated的格式
        // 其實邏輯有錯,不檢查validatePrompt時都應該回傳undefined,有檢查時多綠色勾勾也還好,但一直以來都預設回傳有檢查綠框,所以先保持這樣的爛規則
        return (this.componentType==='b-form-select'? undefined : true)
      }
      else if (!this.isRequired) {
        return (this.componentType==='b-form-select'? undefined : true)
      }
      else {
        // 用truthy判斷,唯一例外是array是空陣列的判斷
        if (this.formDataObj[this.akey]) {
          if (this.formDataObj[this.akey].constructor === Array) {
            return this.formDataObj[this.akey].length > 0? (this.componentType==='b-form-select'? undefined : true) : false
          }
          else {
            return (this.componentType==='b-form-select'? undefined : true)
          }
        }
        else {
          return false
        }
      }
    },
    focusSelf(evt) {
      if (['b-button','span','b-form-checkbox','b-form-checkbox-group','b-form-radio-group','b-form-select'].includes(this.componentType)) {
        return
      }
      else if (!this.hide&&this.$refs.comp.$el.tagName === 'INPUT') {
        // 沒錯就是要多$el才能select()
        this.$refs.comp.$el.select()
        return
      }
      else if (this.componentType === 'vue-single-select' && this.$refs.comp.$refs.search) {
        // 不是那麼必要,只是auto-complete已選再點擊時要select all比較好按而已
        this.$refs.comp.$refs.search.select()
        return
      }
      else {
        evt.preventDefault()
        evt.stopPropagation()
      }
    },
    customEnter () {
      if (this.execCallback !== undefined) {
        this.execCallback()
      }
    },
    setFocus() {
      if ( !['date-picker','vue-single-select'].includes(this.componentType)) {
        this.$refs.comp.focus()
      }
      else {
        //date picker是把input包在裡面的,focus其實就是click才能帶進去
        //之後還要測試其他類型的setFocus支援,b-form-input是可以的,但vue-single-select等是不行的
        this.$refs.comp.$el.click()
      }
    },
    execCommand (execCallback,evt) {
      // 這個類型的control是要輸入完用enter再執行的
      if (this.componentType === 'text' || this.componentType === 'b-form-textarea') {
        return
      }
      if (this.waitClick) {
        this.waiting = true
        this.setDisabled(true)
        if (execCallback !== undefined) {
          execCallback(this.execDone,evt)
        }
      }
      else {
        if (execCallback !== undefined) {
          execCallback(evt)
        }
      }
    },
    execDone () {
      this.setDisabled(false)
      this.waiting = false
    },
  },
  computed: {
    // 這樣的get/set就能動態綁這個input屬性回來源物件的子屬性上了
    // 為了讓FilterForm的v-for簡單,所以控件資料更新要往上emit兩層
    // akey除了給vue-single-select當作DOM的id,也做為form value的key綁定v-model
    modelIndex: {
      get() {
        return this.formDataObj[this.akey]
      },
      set(val) {
        let upd = {
          'type':this.componentType,
          'fkey':this.fkey,
          'key': this.akey,
          'val': val
        }
        // this.validateState = (!this.validatePrompt||!this.isRequired||val)?true:false
        this.$emit('customValueChanged', upd)
        // 因為需要判斷parent的來源數據,所以更新狀態需要在emit事件之後再做
        this.validateState = this.inputValidateCheck()
      }
    },
    whichComponent () {
      if (this.hide) {
        return 'span'
      }
      if (this.$bus.formInputTypes.includes(this.componentType)) {
        return 'b-form-input'
      }
      else if (this.componentType === 'btn-group') {
        return 'div'
      }
      else {
        return this.componentType
      }
    },
    cStyle () {
      let textAlign = this.centerText?'text-align:center;':''
      // 雖然validation prompt共用但style非原生bootstrap控件有額外div仍須這個判斷
      // 仍須再微調 現在警告訊息出現與否仍會微微抖動水平高度,調到完全不會抖才算完善
      switch (this.componentType) {
        case 'vue-single-select':
          //因為結構有點亂,single select下面不接下拉選單時,mobile版面會和下一個控制項黏再一起,所以手機版型時-8px的margin-bottom取消
          //缺點是緊接著下拉選單時下面會多空8px出來,但畢竟是autocomplete用途有點不一樣還可以接受,比黏在一起好
          var pcbottom = this.checkMobile()?'': (this.validatePrompt?'margin-bottom:-9px;':'margin-bottom:-8px;') 
          return "width:100%;"+(this.validatePrompt?('margin-top:-9px;'+pcbottom):('margin-top:8px;'+pcbottom))
        case 'b-form-checkbox':
        case 'b-form-checkbox-group':
          return "width:100%;"+(this.validatePrompt?'':'margin-top:8px;')
        case 'date-picker':
          return "width:100%;"+(this.validatePrompt?'':'margin-top:8px;')
        case 'b-button':
          // 套不進去,只能用class代替
          return ""
        case 'btn-group':
          // mobile版型時要留給margin-right所以無法把12欄配完排版,會很難置中,多一個paddgin-left自動往中間擠一點
          return (this.checkMobile()?'padding-left:2%;':'')+textAlign+"width:100%;"+(this.validatePrompt?'margin-top:1px;':'margin-top:8px;')
        case "star-rating":
          return textAlign+"width:100%;"
        default:
          return textAlign+"width:100%;"+(this.validatePrompt?'margin-top:1px;':'margin-top:8px;')
      }
    },
    cClass () {
      const waitClass = this.waiting?"waiting":""
      if (this.componentType === 'b-button') {
        return (this.validatePrompt?'form-button-prompt':'form-button')+' '+waitClass
      }
      else {
        return waitClass
      }
    },
    validateHint () {
      if (this.validatePrompt && this.validatePromptHint) {
        return this.validatePromptHint
      }
      else {
        return "*必填"
      }
    },
  },
  mounted () {
    // 初始化判斷state是否要警告
    this.dpConfig = this.datePickerConfig
    this.validateState = this.inputValidateCheck() // (!this.validatePrompt||!this.isRequired||this.formDataObj[this.akey])?true:false
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-control::placeholder {
  color: darkgray;
  opacity: 0.75;
  transition: opacity 250ms ease-in-out;
}
.form-control.is-valid {
  background-image: none;
}
/* for timepicker */
.time-picker input.display-time {
  width:100%;
}
.was-validated .custom-select:invalid {
     background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right .75rem center/8px 10px;
}
.feedback-hint {
  font-size:small;
  color:red;
  height:10px;
  margin-top:0px;
  margin-bottom:10px;
  text-align: left;
}
.prompSpace {
  height:21px;
}
.form-button-prompt {
  margin-top:0px;
  margin-bottom:0px;
}
.form-button {
  margin-top:8px;
  padding-top: 8px;
}
.waiting {
  cursor:wait;
}
.hide {
  visibility: hidden;
}
</style>
<!-- extra style section no scoped to override single-select-wrapper style-->
<style>
.single-select-wrapper {
  margin-top: 8px;
  margin-left:0px;
  margin-right:0px;
}
::-webkit-input-placeholder  { /* Chrome */
  color: darkgray;
  opacity: 7.5;
  transition: opacity 250ms ease-in-out;
}

</style>
